import React from 'react'
import { Card, Typography } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClock } from '@fortawesome/free-solid-svg-icons'

const { Title, Paragraph } = Typography

/**
 * Generic Coming Soon component for placeholder pages
 *
 * @param {Object} props - Component props
 * @param {string} [props.title] - Optional custom title (defaults to "Coming Soon")
 * @param {string} [props.message] - Optional custom message
 * @param {string} [props.className] - Optional additional CSS classes
 * @param {string} [props.currentPath] - The route the tab shows (accepted, not rendered)
 * @returns {JSX.Element} Coming Soon component
 */
const ComingSoon = ({
  title = 'Coming Soon',
  message = 'This feature is currently under development and will be available soon.',
  className = '',
  currentPath = '/'
}) => {
  return (
    <div className='h-full'>
      <div className={`flex items-center justify-center min-h-96 p-8 ${className}`}>
        <Card className='text-center max-w-md w-full' style={{ padding: 10 }}>
          <div className='mb-4'>
            <FontAwesomeIcon icon={faClock} size='3x' className='text-blue-500 mb-4' />
          </div>

          <Title level={2} className='mb-4'>
            {title}
          </Title>

          <Paragraph className='text-gray-600 text-lg'>{message}</Paragraph>
        </Card>
      </div>
    </div>
  )
}

export default ComingSoon
